// extracted by mini-css-extract-plugin
export default {"checkBoxContainer":"InfoCheckbox_checkBoxContainer__hCCHg","checkboxInput":"InfoCheckbox_checkboxInput__wtEaD"};